import { parseColor } from "@/utils/parseColor"
function remCheck(value) {
  if (value?.endsWith && value?.endsWith('rem')) {
    // 说明是已经被系统转换过的单位了
    return value
  }
  return value + 'px'
}
const propTrans = {
  backgroundSet: function (backgroundVal = []) {
    let conatinerBg = {
      backgroundImage: ""
    }
    let curBackground = backgroundVal
    if (
      !curBackground ||
      !Array.isArray(curBackground) ||
      (Array.isArray(curBackground) && curBackground.length === 0)
    ) {
      curBackground = [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: '#fff'
        }
      ]
    }
    curBackground.forEach(bg => {
      switch (bg.type) {
        case "img":
          let dot1 = conatinerBg.backgroundImage.length > 0 ? "," : ""
          conatinerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
          conatinerBg.backgroundSize = bg.clipSize
          conatinerBg.backgroundPosition = bg.alignType
          conatinerBg.backgroundRepeat = bg.repeatType
          break
        case "color":
          conatinerBg.backgroundColor = this.colorSet(bg)
          break
        case "linearGradient":
          let tmp = []
          if (bg.data.stops.length > 0) {
            bg.data.stops.forEach(item => {
              tmp.push(item[0] + " " + item[1] * 100 + "%")
            })
            let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
            conatinerBg.backgroundImage += dot + parseColor(bg, {
              renderModel:  'variable'
            })
          }
          break
        case "radialGradient":
          let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : "";
              conatinerBg.backgroundImage +=
                dot +  parseColor(bg, {
                  renderModel:  'variable'
                })
            }
          break
        default:
      }
    })
    return conatinerBg
  },
  colorSet: function(val, isThemeColor) {
    if (typeof val === 'object') {
      const isThemeColorFlag = val?.hasOwnProperty('isThemeColor') ? val.isThemeColor : (isThemeColor ?? false)
      return isThemeColorFlag ? `var(--theme-${val.themeId || 'default'}-${val.colorOpacity ?? 100})` : val.color
    }
    return val
  },
  fontSet: function(val) {
    if (val.fontColor && typeof val.fontColor === 'object') {
      val.fontColor = this.colorSet(val.fontColor, val.textIsThemeColor)
    }
    return val
  },
  simpleFontSet: function(val) {
    if (val.fontColor && typeof val.fontColor === 'object') {
      val.fontColor = this.colorSet(val.fontColor, val.textIsThemeColor)
    }
    if (val.colorMode === 'complex') {
      val.fontColor = this.colorSet(val.colorArr, val.textIsThemeColor)
    }
    if (val.textIsThemeColor) {
      // 如果是主题色
      val.fontColor = 'var(--page-theme-color)'
    }
    return val
  },
  complexFontSet: function(val) {
    val = JSON.parse(JSON.stringify(val))
    if (val.fontColor && typeof val.fontColor === 'object') {
      val.fontColor = this.colorSet(val.fontColor, val.textIsThemeColor)
    }
    if (val.textIsThemeColor) {
      // 如果是主题色
      val.fontColor = 'var(--page-theme-color)'
    }
    if (val.lineHeightType === 'px') {
      val.lineHeight = remCheck(val.lineHeight)
    } else if (val.lineHeightType === '%') {
      val.lineHeight = parseFloat(val.lineHeight) / 100 * parseFloat(val.fontSize) + 'px'
    }
    let tmpStyle = ''
    if (Array.isArray(val.shadowH)) {
      val.shadowH.forEach((item, index) => {
        if (index > 0) {
          tmpStyle += ","
        }
        tmpStyle += `${remCheck(val.shadowH[index])} ${remCheck(val.shadowV[index])} ${remCheck(val.shadowBlur[index])} ${val.shadowColor[index]}`
      })
    } else {
      tmpStyle += `${remCheck(val.shadowH)} ${remCheck(val.shadowV)} ${remCheck(val.shadowBlur)}  ${val.shadowColor}`
    }
    val.textShadow = tmpStyle
    return val
  },
  iconSet: function(val) {
    if (val.iconColor && typeof val.iconColor === 'object') {
      val.iconColor = this.colorSet(val.iconColor)
    }
    // if (val.iconColorIsThemeColor) {
    //   val.iconColor = 'var(--page-theme-color)'
    // }
    val.iconMargin = remCheck(val.iconMargin)
    val.iconWidth = remCheck(val.iconWidth)
    return val
  },
  paddingSet: function (data) {
    const { padding, paddingTypeFlag, paddingLeft, paddingRight, paddingBottom, paddingTop } = data || {}
    if (paddingTypeFlag == 1) {
      return remCheck(padding)
    }
    return `${remCheck(paddingTop || 0)} ${remCheck(paddingRight || 0)} ${remCheck(paddingBottom || 0)} ${remCheck(paddingLeft || 0)}`
  },
  radiusSet: function (data) {
    const { borderRadius, borderTypeFlag, borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius } = data || {}
    if (borderTypeFlag == 2) {
      return remCheck(borderRadius)
    }
    return `${remCheck(borderTopLeftRadius || 0)} ${remCheck(borderTopRightRadius || 0)} ${remCheck(borderBottomRightRadius || 0)} ${remCheck(borderBottomLeftRadius || 0)}`
  },
  shadowSet: function (data) {
    let tmpStyle = ""
    if (Array.isArray(data.boxShadowH)) {
      data.boxShadowH.forEach((item, index) => {
        if (index > 0) {
          tmpStyle += ","
        }
        tmpStyle += `${remCheck(data.boxShadowH[index])} ${remCheck(data.boxShadowV[index])} ${remCheck(data.boxShadowBlur[index])} ${remCheck(data.boxShadowSpread[index])} ${data.boxShadowColor[index]}`
      })
    } else {
      tmpStyle += `${remCheck(data.boxShadowH)} ${remCheck(data.boxShadowV)} ${remCheck(data.boxShadowBlur)} ${remCheck(data.boxShadowSpread)} ${data.boxShadowColor}`
    }
    return tmpStyle
  },
  borderSet: function (data) {
    if (data.showEnableCheckbox) {
      data.borderWidth = data.enable ? data.borderWidth : [0, 0, 0, 0]
    }
    if (data.borderColor) {
      data.borderColor = this.colorSet(data.borderColor)
    }
    return data
  },
  sizeSet: function(data) {
    return {
      width: data.widthAuto ? 'auto' : data.widthFull ? '100vw' : data.widthCenter ? "widthCenter" : remCheck(data.widthVal),
      height: data.heightAuto ? 'auto' : remCheck(data.heightVal),
    }
  },
  marginSet: function(data) {
    return {
      leftMargin: remCheck(data.leftMargin),
      topMargin: remCheck(data.topMargin)
    }
  }
}

export default propTrans
